// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D1pBndkSNwKmdqGEiZF2{font-family:var(--font-cool);font-size:3rem}`, "",{"version":3,"sources":["webpack://./src/components/Player/PlayerResult.module.scss"],"names":[],"mappings":"AAAA,sBACE,4BAAA,CACA,cAAA","sourcesContent":[".result {\n  font-family: var(--font-cool);\n  font-size: 3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"result": `D1pBndkSNwKmdqGEiZF2`
};
export default ___CSS_LOADER_EXPORT___;
